WiseMetering.Model.Invoice = WiseMetering.Model.extend({
    urlRoot: '/invoices',

    fileLink: function() {
        return this.get('file') ? WiseMetering.apiUrl + this.url() + '/file' : null;
    },

    indicator: function() {
        return this.utility().indicator();
    },

    indicatorKind: function() {
        return this.indicator().kind();
    },

    invoiceValidationStatus: function() {
        if (this.get('check').status === 'checked') {
            return 'Validation checked, deviation < 2,5%';
        } else if (this.orangeDeviationCondition()) {
            return 'Validation not checked, deviation < 5%';
        } else if (this.get('check').status === 'not_checked') {
            return 'Validation not checked, deviation >= 5%';
        }

        return 'Validation process failed';
    },

    orangeDeviationCondition: function() {
        const threshold = 5,
            consumption = Math.abs(this.get('check').consumption),
            cost = Math.abs(this.get('check').cost),
            notChecked = this.get('check').status === 'not_checked';

        return notChecked && consumption < threshold && cost < threshold;
    },

    removeFile: function() {
        return this.save({}, {
            url: this.url() + '/remove_file',
            wait: true,
            patch: true
        });
    },

    site: function() {
        return this.utility().site();
    },

    statusColor: function() {
        if (this.get('check').status === 'checked') {
            return 'green';
        } else if (this.orangeDeviationCondition()) {
            return 'orange';
        } else if (this.get('check').status === 'not_checked') {
            return 'red';
        }

        return 'blue';
    },

    statusIcon: function() {
        if (this.get('check').status === 'checked') {
            return 'check';
        } else if (this.orangeDeviationCondition()) {
            return 'exclamation';
        } else if (this.get('check').status === 'not_checked') {
            return 'times';
        }

        return 'question';
    },

    timezone: function() {
        return this.site().get('timezone');
    },

    unit: function() {
        return this.indicatorKind().get('unit');
    },

    uploadFile: function(formData) {
        return this.save({}, {
            url: this.url(),
            contentType: false,
            data: formData,
            processData: false
        });
    },

    utility: function() {
        return WiseMetering.utilities.get(this.get('utility_id'));
    },

    utilityKind: function() {
        return this.utility().utilityKind();
    }
});
